import * as Actions from "../actions";

const initialState = {
  loading: false,
  whitelisted: [],
  customLoader: false,
  authLoading: false,
  user: {},
  authenticated: false,
  availablePermissions: [],
  volumes: [],
  transactionsChartData: [],
  partnerDiscount: null,
  transactions: [],
  withdrawHistory: [],
  activeWallet: "",
  withdrawFeesMsg: "",
  errorMsg: "",
  apiRequests: [],
  page: "overview",
  updatedClientEmailResponse: "",
  updatedWhitelistedIpsResponse: "",
  availableChains: [],
  availableCurrencies: [],
  whitelistedIps: [],
  whitelistedWebsites: [],
  webhookConfig: {},
  walletAudit: { items: [], total: 0, page: 1, itemsPerPage: 25 },
  walletAuditLoading: false,
  partnerWallets: [],
  partnerWalletsLoading: false,
  unlinkedWallets: [],
  unlinkedWalletsLoading: false,
  subFees: [],
  subFeesLoading: false,
  subAffiliateFees: null,
  subAffiliateFeesLoading: false,
  twoFactor: { enabled: false, loginRequired: false, enrolledAt: null, loaded: false },
  twoFactorLoading: false,
};

const userReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.LOGIN_USER: {
      return {
        ...state,
        user: action.payload,
        loading: false,
        authenticated: true,
      };
    }
    case Actions.TWO_FACTOR_STATUS:
      return {
        ...state,
        twoFactor: action.payload,
      };
    case Actions.TWO_FACTOR_LOADING:
      return {
        ...state,
        twoFactorLoading: action.payload,
      };
    case Actions.LOGOUT_USER:
      return {
        ...state,
        authenticated: false,
      };
    case Actions.CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        changePasswordResponse: action.payload,
        changePasswordError: null,
      };
    case Actions.CHANGE_PUBLIC_NAME_SUCCESS:
      return {
        ...state,
        loading: false,
        user: {
          ...state.user,
          response: {
            ...state.user.response,
            partnerPublicName: action.payload.newPublicName,
          },
        },
      };
    case Actions.CHANGE_PUBLIC_NAME_ERROR:
      return {
        ...state,
        loading: false,
        errorMsg: action.payload,
      };
    case Actions.AVAILABLE_PERMISSIONS: {
      return {
        ...state,
        permissions: action.payload,
      };
    }
    case Actions.GET_VOLUMES: {
      return {
        ...state,
        volumes: action.payload,
      };
    }
    case Actions.GET_TRANSACTIONS_CHART_DATA: {
      return {
        ...state,
        transactionsChartData: action.payload,
      };
    }
    case Actions.GET_PARTNER_DISCOUNT: {
      return {
        ...state,
        partnerDiscount: action.payload,
      };
    }
    case Actions.API_REQUEST_LIMITS: {
      return {
        ...state,
        apiRequests: action.payload,
      };
    }
    case Actions.GET_USER_TRANSACTIONS: {
      return {
        ...state,
        transactions: action.payload,
      };
    }
    case Actions.GET_USER_WITHDRAW_HISTORY: {
      return {
        ...state,
        withdrawHistory: action.payload,
      };
    }
    case Actions.GET_ACTIVE_WALLET: {
      return {
        ...state,
        activeWallet: action.payload,
      };
    }
    case Actions.CHANGE_WALLET: {
      return {
        ...state,
        activeWallet: action.payload,
      };
    }
    case Actions.WITHDRAW_FEES: {
      return {
        ...state,
        withdrawFeesMsg: action.payload,
      };
    }
    case Actions.LOADING_STATE: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case Actions.CUSTOM_LOADER: {
      return {
        ...state,
        customLoader: action.payload,
      };
    }
    case Actions.CHANGE_PAGE: {
      return {
        ...state,
        page: action.payload,
      };
    }
    case Actions.AUTHENTICATED_USER: {
      return {
        ...state,
        authenticated: true,
        user: action.payload,
        authLoading: false,
      };
    }

    case Actions.UPDATE_CLIENT_EMAIL:
      return {
        ...state,
        updatedClientEmailResponse: action.payload,
      };
    case Actions.CHANGE_ERROR_MESSAGE: {
      return {
        ...state,
        errorMsg: action.payload,
      };
    }
    case Actions.AVAILABLE_CHAINS: {
      return {
        ...state,
        availableChains: action.payload,
      };
    }
    case Actions.AVAILABLE_CURRENCIES: {
      return {
        ...state,
        availableCurrencies: action.payload,
      };
    }
    case Actions.AUTH_LOADING: {
      return {
        ...state,
        authLoading: action.payload,
      };
    }
    case Actions.UPDATE_BPS: {
      return {
        ...state,
        user: {
          ...state.user,
          response: {
            ...state.user.response,
            bps: action.payload,
          },
        },
      };
    }
    case Actions.UPDATE_ACCOUNT_TYPE: {
      return {
        ...state,
        user: {
          ...state.user,
          response: {
            ...state.user.response,
            accountType: action.payload,
          },
        },
      };
    }
    case Actions.GET_WHITELISTED_IPS:
      return {
        ...state,
        whitelistedIps: action.payload,
      };
    case Actions.ADD_WHITELISTED_IP:
      return {
        ...state,
        loading: false,
        updatedWhitelistedIpsResponse: action.payload,
        whitelistedIps: [...state.whitelistedIps, action.payload],
      };
    case Actions.DELETE_WHITELISTED_IP:
      return {
        ...state,
        whitelistedIps: state.whitelistedIps.filter(ip => ip !== action.payload),
      };
    case Actions.GET_WHITELISTED_WEBSITES:
      return {
        ...state,
        whitelistedWebsites: action.payload,
      };
    case Actions.ADD_WHITELISTED_WEBSITE:
      return {
        ...state,
        loading: false,
        whitelistedWebsites: [...state.whitelistedWebsites, action.payload],
      };
    case Actions.DELETE_WHITELISTED_WEBSITE:
      return {
        ...state,
        whitelistedWebsites: state.whitelistedWebsites.filter(url => url !== action.payload),
      };

    case Actions.GET_WEBHOOK_CONFIG:
    case Actions.SAVE_WEBHOOK_CONFIG:
      return {
        ...state,
        webhookConfig: action.payload,
      };

    case Actions.GET_OWN_WALLET_AUDIT:
      return {
        ...state,
        walletAudit: action.payload,
      };
    case Actions.GET_OWN_WALLET_AUDIT_LOADING:
      return {
        ...state,
        walletAuditLoading: action.payload,
      };
    case Actions.UPDATE_PARTNER_WALLET_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          response: {
            ...state.user?.response,
            walletAddress:
              action.payload?.walletAddress ??
              state.user?.response?.walletAddress,
          },
        },
      };

    case Actions.LIST_PARTNER_WALLETS:
      return {
        ...state,
        partnerWallets: action.payload,
      };
    case Actions.LIST_PARTNER_WALLETS_LOADING:
      return {
        ...state,
        partnerWalletsLoading: action.payload,
      };
    case Actions.FIND_UNLINKED_WALLETS:
      return {
        ...state,
        unlinkedWallets: action.payload,
      };
    case Actions.FIND_UNLINKED_WALLETS_LOADING:
      return {
        ...state,
        unlinkedWalletsLoading: action.payload,
      };

    case Actions.GET_SUB_FEES:
      return {
        ...state,
        subFees: action.payload,
      };
    case Actions.GET_SUB_FEES_LOADING:
      return {
        ...state,
        subFeesLoading: action.payload,
      };
    case Actions.CREATE_SUB_FEE:
      return {
        ...state,
        subFees: [...state.subFees, action.payload],
      };
    case Actions.UPDATE_SUB_FEE:
      return {
        ...state,
        subFees: state.subFees.map((sf) =>
          sf.subAffiliateId === action.payload.subAffiliateId
            ? { ...sf, ...action.payload }
            : sf
        ),
      };
    case Actions.DELETE_SUB_FEE:
      return {
        ...state,
        subFees: state.subFees.filter(
          (sf) => sf.subAffiliateId !== action.payload
        ),
      };
    case Actions.GET_SUB_AFFILIATE_FEES:
      return {
        ...state,
        subAffiliateFees: action.payload,
      };
    case Actions.GET_SUB_AFFILIATE_FEES_LOADING:
      return {
        ...state,
        subAffiliateFeesLoading: action.payload,
      };

    default: {
      return state;
    }
  }
};

export default userReducer;
